import type { RuoloDTO } from '@/models/dto/utente/ruolo-dto'
import type { Role } from '@/models/types/user/role'

const mapToRuoliDTO = (role: Partial<Role>): Partial<RuoloDTO> => {
    return { id: role.id, nomeRuolo: role.name }
}

const mapToRole = (ruoliDTO: Partial<RuoloDTO>): Partial<Role> => {
    return { id: ruoliDTO.id, name: ruoliDTO.nomeRuolo ?? undefined }
}

export { mapToRole, mapToRuoliDTO }
